import { api } from "../http";
import { ApiResponse } from "../types";
import {
  DashboardRequest,
  DashboardResponse,
  StudentValidityInfoResponse,
  SmsWalletResponse,
} from "../interfaces/DashboardInterface";

export const getDashboardDetails = async (
  request: DashboardRequest
): Promise<ApiResponse<DashboardResponse>> => {
  try {
    const response = await api.post<ApiResponse<DashboardResponse>>(
      "/Dashboard/GetDashboardDetails",
      request
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Dashboard details:", error);
    throw error;
  }
};

export const getUpcomingPaymentList = async (): Promise<
  ApiResponse<StudentValidityInfoResponse[]>
> => {
  try {
    const response = await api.get<ApiResponse<StudentValidityInfoResponse[]>>(
      "/Dashboard/GetUpcomingPaymentList"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Dashboard details:", error);
    throw error;
  }
};

export const getSmsWalletBalance = async (): Promise<
  ApiResponse<SmsWalletResponse>
> => {
  try {
    const response = await api.post<ApiResponse<SmsWalletResponse>>(
      "/Dashboard/GetSmsWalletBalance"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching SMS wallet balance:", error);
    throw error;
  }
};
